"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyCheckBox = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const common_1 = require("../../../../common");
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const SurveyCheckBox = ({ id, className, isRadioButton = false, defaultList = [], isRegist = false, isSubmit = false, isDisable = false, setChangeSurveyData, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const [list, setList] = (0, react_1.useState)(defaultList);
    react_1.default.useEffect(() => {
        if (!isSubmit)
            return;
        setList(defaultList);
    }, [defaultList, isSubmit]);
    const handlerCheck = (id, checked) => {
        if (isRadioButton) {
            setList(prevList => {
                return prevList.map(item => {
                    if (item.id === id) {
                        return { ...item, checked: true };
                    }
                    return { ...item, checked: false };
                });
            });
        }
        else {
            setList(prevList => {
                return prevList.map(item => {
                    if (item.id === id) {
                        return { ...item, checked };
                    }
                    return item;
                });
            });
        }
    };
    const onChange = (id, value) => {
        setList(prevList => {
            return prevList.map(item => {
                if (item.id === id) {
                    return { ...item, title: value };
                }
                return item;
            });
        });
    };
    const handleAddOption = e => {
        setList(prevList => [
            ...prevList,
            { id: `id-${Date.now()}`, title: undefined, checked: false },
        ]);
    };
    const handleDelete = (id) => {
        setList(prevList => prevList.filter(item => item.id !== id));
    };
    react_1.default.useEffect(() => {
        setChangeSurveyData &&
            setChangeSurveyData({
                id: id,
                data: list,
            });
    }, [list]);
    return (react_1.default.createElement("div", { className: `checkbox flex column ${className}` },
        list &&
            typeof list !== 'string' &&
            list.map((item) => (react_1.default.createElement("div", { key: item.id, className: "survey_checkbox_item" },
                react_1.default.createElement(common_1.CheckBoxElement, { key: item.id, iconSize: isMobile ? 18 : 24, isRadioButton: isRadioButton, ...item, option: {
                        input: {
                            show: isRegist,
                            placeholder: t('survey.inputAnswerPlaceholder'),
                            className: 'body4',
                            onChange,
                        },
                    }, handlerCheck: isDisable ? undefined : handlerCheck, style: { justifyContent: 'flex-start' }, isDisable: isSubmit }),
                isRegist && (react_1.default.createElement("p", { className: "del_btn", onClick: () => handleDelete(item.id) }, "\uC0AD\uC81C"))))),
        isRegist && (react_1.default.createElement("label", { className: "flex row center", onClick: handleAddOption, style: { justifyContent: 'flex-start' } },
            react_1.default.createElement(common_1.Icon, { icon: isRadioButton ? 'radio_unchecked' : 'unchecked', size: isMobile ? 18 : 25 }),
            react_1.default.createElement("div", { className: "body4 add-item-text" }, t('common.add'))))));
};
exports.SurveyCheckBox = SurveyCheckBox;
